import { useQuery } from "@tanstack/react-query";
import { StorageAPI } from "@repo/api";
import { useAuth } from "@repo/context/auth/auth";
import { storageKeys } from "@repo/query/keys";
import { isStorageQuotaExhausted } from "./quota";

/**
 * 云空间配额。web / webview 共用；MinePanel、设置页、模板详情、上传页同时挂载时只发一次请求。
 * 未登录时不请求（`enabled: false`），此时 `isPending` 会一直为 true，判断加载态请用 `isLoading`。
 * 购买 / 转永久存储等写操作后用 `invalidateQueries({ queryKey: storageKeys.quota() })` 刷新。
 */
export function useStorageQuota() {
  const { isAuthenticated } = useAuth();

  const query = useQuery({
    queryKey: storageKeys.quota(),
    queryFn: () => StorageAPI.getQuotaInfo().then((r) => r.data),
    enabled: isAuthenticated === true,
  });

  return {
    ...query,
    isExhausted: isStorageQuotaExhausted(query.data),
  };
}
